var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.547,
    height: 142.775,
    viewBox: "0 0 127.547 142.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;stroke-linecap:round;}.b{stroke:#898b8d;stroke-width:2px;}.c{stroke:#000;}.d{fill:#d9ffff;}.e{fill:#d96e82;}.f{fill:#d88d9b;}.g{fill:#28a745;}.h{fill:#464646;font-size:12px;font-family:Barlow-SemiBold, Barlow;font-weight:600;letter-spacing:0.028em;}.i{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 126.444,
    height: 137.98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15099 -8739.667)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 15099, 8739.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.373,0H99.214c.24,0,4.334.009,4.96.065,4.373.325,4.27.45,4.27,5.307V110.751a9.229,9.229,0,0,1-9.229,9.229H5.373C.276,119.98,0,119.7,0,114.607V5.373C0,.276.276,0,5.373,0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H66.723",
    transform: "translate(15137.615 8798.34)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 66.938,
    transform: "translate(15137.615 8809.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H66.723",
    transform: "translate(15137.615 8821.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M396.722,382.25c-6.345.577-13.267,12.69-7.5,14.421s9.806-4.615,9.806-4.615.577,5.768,2.307,4.615,3.379.822,2.39-3.132a24.642,24.642,0,0,0-2.39-6.262l7.334,9.394s-.33,6.1-2.637,5.439,0-8.571,2.637-10.054a58.866,58.866,0,0,0,6.592-4.779s-2.637,6.262,0,4.779a18.637,18.637,0,0,0,4.945-4.779v4.779s1.648,2.8,3.956,0,3.956,1.154,5.274,0",
    transform: "translate(14755.693 8452.957)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15186.415 8826.555)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1733.316,968.445h0c0-.067,0-.1,0-.1C1733.317,968.354,1733.316,968.445,1733.316,968.445Z",
    transform: "translate(-1733.149 -957.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1733.316,968.445h0c0-.067,0-.1,0-.1C1733.317,968.354,1733.316,968.445,1733.316,968.445Z",
    transform: "translate(-1733.149 -957.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2074.073,972.2s0-.09,0-.1c0,.007,0,.036,0,.1Z",
    transform: "translate(-2033.942 -961.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2074.073,972.2s0-.09,0-.1c0,.007,0,.036,0,.1Z",
    transform: "translate(-2033.942 -961.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1752.2,878.7c-4.69,4.935-12.149,8.956-20.112,10.638-.006.529-.039,3.458-.189,16.958-.2,18.009,16.96,26.922,19.625,28.291,2.6-1.17,20.092-9.843,20.292-27.852.15-13.5.183-16.429.188-16.958C1764.076,887.92,1756.776,883.736,1752.2,878.7Z",
    transform: "translate(-1731.893 -878.699)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.174 3.222)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1768.492,906.45a42.362,42.362,0,0,1-17.888,9.1l-.17,15.259c-.078,6.982,2.667,13.316,8.158,18.828a39.614,39.614,0,0,0,9.343,6.894l.266-.135.33-49.916Z",
    transform: "translate(-1750.432 -906.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1902.254,906.438l-.321,49.984a39.639,39.639,0,0,0,9.228-6.552c5.612-5.39,8.5-11.662,8.574-18.644l.17-15.259A42.505,42.505,0,0,1,1902.254,906.438Z",
    transform: "translate(-1884.165 -906.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M82.462.449,85.77,21.155l-3.308,28.31-.831.43L82.2-.152Z",
    transform: "translate(-64.098 0.152)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.976 17.017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1834.086,1093.833l-.078,11.821c-.009,1.316,16.137,1.422,16.146.106l.078-11.821Zm8.848,6.336-.022,3.35a.817.817,0,0,1-1.634-.01l.022-3.358a1.987,1.987,0,1,1,1.633.018Z",
    transform: "translate(-1834.008 -1085.619)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1860.1,1031.26l-1.635-.01.006-.8a5.025,5.025,0,0,0-10.05-.066l-.005.8-1.634-.011.005-.8a6.659,6.659,0,0,1,13.318.087Z",
    transform: "translate(-1845.284 -1023.792)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M6.1,11.077,4.094,8.914l-.684.731,2.692,2.9,5.779-6.223L11.2,5.59Z",
    transform: "translate(15116.185 8788.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M6.1,11.077,4.094,8.914l-.684.731,2.692,2.9,5.779-6.223L11.2,5.59Z",
    transform: "translate(15116.185 8800.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M6.1,11.077,4.094,8.914l-.684.731,2.692,2.9,5.779-6.223L11.2,5.59Z",
    transform: "translate(15116.185 8811.728)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(15161.35 8762.836)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.439,
    y: 0
  }, "Aviso de"), /*#__PURE__*/React.createElement("tspan", {
    x: -29.436,
    y: 14
  }, "Privacidad")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacidad);
export default __webpack_public_path__ + "static/media/privacidad.ec23b374d9bf414e2557de01db01b349.svg";
export { ForwardRef as ReactComponent };